"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _models = require("@seedlang/models");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _bowser = _interopRequireDefault(require("bowser"));
var _audio_recorder_store = _interopRequireDefault(require("./audio_recorder_store"));
var _video_recorder_store = _interopRequireDefault(require("./video_recorder_store"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
var MAX_AUDIO_LEVEL = 100;
var LEVEL_MULTIPLIER = 230;
var MediaStore = (_class = /*#__PURE__*/function () {
  function MediaStore() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, MediaStore);
    (0, _initializerDefineProperty2["default"])(this, "audioStreamInstantiated", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "mediaType", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "objectUrl", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "isRecording", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "audioLevel", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "maxAudioLevel", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "data", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "stream", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "secondsElapsed", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "startRecordingTimestamp", _descriptor10, this);
    (0, _initializerDefineProperty2["default"])(this, "endRecordingTimestamp", _descriptor11, this);
    (0, _initializerDefineProperty2["default"])(this, "startPlayingTimestamp", _descriptor12, this);
    (0, _initializerDefineProperty2["default"])(this, "pausePlayingTimestamp", _descriptor13, this);
    (0, _initializerDefineProperty2["default"])(this, "playing", _descriptor14, this);
    (0, _initializerDefineProperty2["default"])(this, "initialPlayHasFinished", _descriptor15, this);
    (0, _initializerDefineProperty2["default"])(this, "currentTime", _descriptor16, this);
    (0, _initializerDefineProperty2["default"])(this, "url", _descriptor17, this);
    (0, _initializerDefineProperty2["default"])(this, "durationFromDatabase", _descriptor18, this);
    (0, _initializerDefineProperty2["default"])(this, "isNative", _descriptor19, this);
    (0, _initializerDefineProperty2["default"])(this, "hasNativeSound", _descriptor20, this);
    (0, _initializerDefineProperty2["default"])(this, "canRecord", _descriptor21, this);
    (0, _initializerDefineProperty2["default"])(this, "nativeSoundIsLoading", _descriptor22, this);
    (0, _initializerDefineProperty2["default"])(this, "autoPlay", _descriptor23, this);
    this.streams = [];
    this.isNative = params.isNative;
    this.parent = params.parent;
    if (!this.isNative) {
      this.setupAudio();
      this.audioStream = new _models.AudioStream();
    }
  }
  return (0, _createClass2["default"])(MediaStore, [{
    key: "normalizedAudioLevel",
    get: function get() {
      var level = Math.round(this.audioLevel * LEVEL_MULTIPLIER);
      if (level > MAX_AUDIO_LEVEL) {
        level = MAX_AUDIO_LEVEL;
      }
      return level;
    }
  }, {
    key: "duration",
    get: function get() {
      if (this.durationFromDatabase) {
        return this.durationFromDatabase;
      }
      if (this.endRecordingTimestamp && this.startRecordingTimestamp && this.endRecordingTimestamp > 0 && this.startRecordingTimestamp > 0) {
        return Math.round((this.endRecordingTimestamp - this.startRecordingTimestamp) / 1000 * 10) / 10;
      }
      return null;
    }
  }, {
    key: "hasUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.url);
    }
  }, {
    key: "durationString",
    get: function get() {
      return "".concat(this.duration, "s");
    }
  }, {
    key: "hasMicAccess",
    get: function get() {
      return !this.parent || !this.parent.deviceDeniedAccess;
    }
  }, {
    key: "hasObjectUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.objectUrl);
    }
  }, {
    key: "hasRecording",
    get: function get() {
      return (0, _utils.isPresent)(this.data);
    }
  }, {
    key: "hasFinishedRecording",
    get: function get() {
      return !this.isRecording && ((0, _utils.isPresent)((0, _mobx.toJS)(this.data)) || this.hasNativeSound);
    }
  }, {
    key: "waitingForRecording",
    get: function get() {
      return this.hasMicAccess ? this.isRecording || !this.hasRecording : false;
    }
  }, {
    key: "set",
    value: function set(obs, value) {
      this[obs] = value;
    }
  }, {
    key: "timeDisplay",
    get: function get() {
      var divisorMinutes = this.secondsElapsed % (60 * 60);
      var minutes = Math.floor(divisorMinutes / 60);
      var divisorSeconds = divisorMinutes % 60;
      var seconds = Math.ceil(divisorSeconds);
      return "".concat(minutes < 10 ? 0 : '').concat(minutes, ":").concat(seconds < 10 ? 0 : '').concat(seconds);
    }
  }, {
    key: "setNativeAudioRecorder",
    value: function setNativeAudioRecorder(nativeAudioRecorder) {
      this.nativeAudioRecorder = nativeAudioRecorder;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.stopSecondsElapsed();
    }
  }, {
    key: "startSecondsElapsed",
    value: function startSecondsElapsed() {
      var _this = this;
      this.startRecordingTimestamp = +new Date();
      this.interval = setInterval(function () {
        return _this.secondsElapsed += 1;
      }, 1000);
    }
  }, {
    key: "stopSecondsElapsed",
    value: function stopSecondsElapsed() {
      this.endRecordingTimestamp = +new Date();
      clearInterval(this.interval);
    }
  }, {
    key: "setMediaType",
    value: function setMediaType(mediaType) {
      this.mediaType = mediaType;
    }
  }, {
    key: "recordAudio",
    value: function recordAudio() {
      if (this.mediaType === 'audio') {
        this.startRecording();
      } else {
        this.setupAudio(this.record);
      }
    }
  }, {
    key: "setupVideo",
    value: function setupVideo(params, callback) {
      if (!this.isNative && this.mediaType !== 'video' || this.afterDeviceGrantedAccess !== callback) {
        this.mediaType = 'video';
        this.getUserMediaWithCallback(params, callback);
      }
    }
  }, {
    key: "setupAudio",
    value: function setupAudio(callback) {
      if (!this.isNative && this.mediaType !== 'audio') {
        this.getUserMediaWithCallback({
          audio: true,
          video: false
        }, callback);
        this.mediaType = 'audio';
      }
    }
  }, {
    key: "getUserMediaWithCallback",
    value: function getUserMediaWithCallback(params, callback) {
      if (callback) {
        this.afterDeviceGrantedAccess = callback;
      }
      if (!this.isNative && !_bowser["default"].ios && !_bowser["default"].safari) {
        (0, _utils.getUserMedia)(params, this.onDeviceGrantedAccess, this.onDeviceDeniedAccess);
      }
    }
  }, {
    key: "onDeviceGrantedAccess",
    value: function onDeviceGrantedAccess(stream) {
      this.streams.push(stream);
      this.stream = stream;
      this.setupRecorder();
      if ((0, _lodash.isFunction)(this.afterDeviceGrantedAccess)) {
        this.afterDeviceGrantedAccess(stream);
      }
    }
  }, {
    key: "setupRecorder",
    value: function setupRecorder() {
      if (this.parent && !this.parent.deviceDeniedAccess) {
        if (!this.audioStreamInstantiated) {
          this.audioStreamInstantiated = true;
          this.audioStream.onStreamSuccess(this.stream, this.onAudioLevelUpdate);
        }
        if (this.mediaType === 'video') {
          this.recorder = new _video_recorder_store["default"](this.stream, this.onHandleData);
        } else if (this.mediaType === 'audio') {
          this.recorder = new _audio_recorder_store["default"](this.stream, this.onHandleData);
        }
      }
    }
  }, {
    key: "clearVideoStream",
    value: function clearVideoStream() {
      (0, _lodash.each)(this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (track.kind === 'video') {
            track.stop();
          }
        });
      });
      this.streams = [];
    }
  }, {
    key: "clearAudioStream",
    value: function clearAudioStream() {
      this.mediaType = null;
      this.audioStreamInstantiated = false;
      (0, _lodash.each)(this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (track.kind === 'audio') {
            track.stop();
          }
        });
      });
      this.streams = [];
    }
  }, {
    key: "onHandleData",
    value: function onHandleData(e) {
      if (this.isRecording && e.data && e.data.size > 0) {
        this.data.push(e.data);
      }
    }
  }, {
    key: "onAudioLevelUpdate",
    value: function onAudioLevelUpdate(audioLevel) {
      this.audioLevel = audioLevel;
      if (this.normalizedAudioLevel > this.maxAudioLevel) {
        this.maxAudioLevel = this.normalizedAudioLevel;
      }
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      if (this.isNative || this.recorder) {
        this.onSoftReset();
        this.startSecondsElapsed();
        this.startRecordingTimestamp = +new Date();
        this.isRecording = true;
      }
      if (this.isNative && this.nativeAudioRecorder) {
        this.nativeAudioRecorder.startRecording({
          callback: this.updateScreenForRecordingStatus
        });
      } else if (this.recorder) {
        this.audioStream.startMonitor();
        this.recorder.record();
      }
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.autoPlay = params.autoPlay;
      if (!this.isRecording) {
        return;
      }
      if (this.isNative || this.recorder) {
        this.stopSecondsElapsed();
        this.audioLevel = 0;
        this.endRecordingTimestamp = +new Date();
        this.isRecording = false;
      }
      if (this.isNative) {
        if (!params.skipCallback) {
          this.nativeSoundIsLoading = true;
        }
        if (this.nativeAudioRecorder) {
          this.nativeAudioRecorder.stopRecording({
            callback: this.updateScreenForSoundStatus
          });
        }
      } else if (this.recorder) {
        this.audioStream.stopMonitor();
        this.recorder.stop();
        if (!params.skipCreateObjectURL && (0, _utils.isPresent)(this.data)) {
          this.objectUrl = this.createObjectURL(this.createBlob());
        }
      }
      // EventStore.create({data: {eventType: 'deck - finish recording', params: {duration_in_seconds: this.duration}}}, () => {});
    }
  }, {
    key: "updateScreenForRecordingStatus",
    value: function updateScreenForRecordingStatus(status) {
      this.canRecord = status.canRecord;
      if (status.metering) {
        var linearAudioLevel = Math.pow(10, status.metering / 20) * 160;
        this.onAudioLevelUpdate(linearAudioLevel / LEVEL_MULTIPLIER);
      }
      if (status.isDoneRecording && status.durationMillis) {
        this.durationFromDatabase = Math.round(status.durationMillis / 1000 * 10) / 10;
      }
    }
  }, {
    key: "updateScreenForSoundStatus",
    value: function updateScreenForSoundStatus(status) {
      var _this2 = this;
      if (this.playing && status.didJustFinish) {
        this.playing = false;
        this.pausePlayingTimestamp = +new Date();
        clearInterval(this.interval);
      } else if (!this.hasNativeSound && status.isLoaded) {
        this.nativeAudioRecorder.setCanPlay(true);
        this.hasNativeSound = true;
        this.nativeSoundIsLoading = false;
        if (this.autoPlay && this.nativeAudioRecorder) {
          setTimeout(function () {
            return _this2.play();
          }, 250);
        }
      }
    }
  }, {
    key: "createObjectURL",
    value: function createObjectURL(file) {
      if (window.webkitURL) {
        return window.webkitURL.createObjectURL(file);
      }
      if (window.URL && window.URL.createObjectURL) {
        return window.URL.createObjectURL(file);
      }
      return null;
    }
  }, {
    key: "onSoftReset",
    value: function onSoftReset() {
      if (this.isNative && this.nativeAudioRecorder) {
        this.nativeAudioRecorder.onReset();
      }
      this.audioStreamInstantiated = false;
      this.isRecording = false;
      this.audioLevel = 0;
      this.maxAudioLevel = 0;
      this.durationFromDatabase = this.isNative ? null : this.durationFromDatabase;
      this.startRecordingTimestamp = null;
      this.endRecordingTimestamp = null;
      this.startPlayingTimestamp = null;
      this.pausePlayingTimestamp = null;
      this.data = [];
      this.objectUrl = null;
      this.secondsElapsed = 0;
      this.hasNativeSound = false;
    }
  }, {
    key: "onReset",
    value: function onReset() {
      if (this.audio) {
        this.audio.src = '';
      }
      this.pause();
      this.playing = false;
      this.currentTime = 0;
      this.initialPlayHasFinished = false;
      this.onSoftReset();
    }
  }, {
    key: "onDeviceDeniedAccess",
    value: function onDeviceDeniedAccess() {
      if (this.parent) {
        this.parent.set('deviceDeniedAccess', true);
      }
    }
  }, {
    key: "getFormData",
    value: function getFormData() {
      var formData = new FormData();
      formData.append('blob', this.createBlob());
      return formData;
    }
  }, {
    key: "createBlob",
    value: function createBlob() {
      return this.recorder.createBlob(this.data);
    }
  }, {
    key: "setupAudioPlayer",
    value: function setupAudioPlayer(audioEl, url, duration) {
      this.durationFromDatabase = duration;
      this.audio = audioEl;
      if (this.hasRecording) {
        this.setUrl(this.objectUrl);
      } else if (url) {
        this.setUrl(url);
      }
    }
  }, {
    key: "setUrl",
    value: function setUrl(url) {
      if (this.audio) {
        this.url = url;
        this.audio.src = url;
        this.audio.addEventListener('ended', this.onEnd.bind(this));
      }
    }
  }, {
    key: "onTogglePlay",
    value: function onTogglePlay() {
      this.playing ? this.pause() : this.play();
    }
  }, {
    key: "play",
    value: function play() {
      var _this3 = this;
      if (this.isNative) {
        this.playing = true;
        this.startPlayingTimestamp = +new Date();
        if (this.hasNativeSound && this.nativeAudioRecorder) {
          this.nativeAudioRecorder.play();
        }
      } else if (this.audio && (this.hasRecording || this.hasUrl)) {
        var promise = this.audio.play();
        if (promise !== undefined) {
          promise.then(function () {
            _this3.playing = true;
            _this3.startPlayingTimestamp = +new Date();
            clearInterval(_this3.interval);
            _this3.interval = setInterval(_this3.updateTimer.bind(_this3), 10);
          })["catch"](function (error) {
            // Sentry.captureException(error);
            throw error;
            console.warn('warning, audio play was blocked');
          });
        }
      }
    }
  }, {
    key: "updateTimer",
    value: function updateTimer() {
      this.currentTime = this.audio.currentTime;
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.playing) {
        return;
      }
      if (this.isNative || this.audio) {
        this.playing = false;
        this.pausePlayingTimestamp = +new Date();
        clearInterval(this.interval);
      }
      if (this.isNative && this.nativeAudioRecorder) {
        this.nativeAudioRecorder.pause();
      } else if (this.audio) {
        this.audio.pause();
      }
    }
  }, {
    key: "onEnd",
    value: function onEnd() {
      clearInterval(this.interval);
      this.currentTime = 0;
      this.playing = false;
      this.initialPlayHasFinished = true;
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioStreamInstantiated", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "mediaType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "objectUrl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maxAudioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stream", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "secondsElapsed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "endRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startPlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pausePlayingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "playing", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "initialPlayHasFinished", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "currentTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "url", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationFromDatabase", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isNative", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasNativeSound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "canRecord", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeSoundIsLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "autoPlay", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "normalizedAudioLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedAudioLevel"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "duration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "durationString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "durationString"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasMicAccess", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMicAccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasObjectUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasFinishedRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFinishedRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "waitingForRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitingForRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "set", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "timeDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeDisplay"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setNativeAudioRecorder", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeAudioRecorder"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "dispose", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "dispose"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startSecondsElapsed", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "startSecondsElapsed"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stopSecondsElapsed", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "stopSecondsElapsed"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setMediaType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setMediaType"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "recordAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "recordAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupVideo"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getUserMediaWithCallback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getUserMediaWithCallback"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onDeviceGrantedAccess", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onDeviceGrantedAccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupRecorder", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupRecorder"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "clearVideoStream", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearVideoStream"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "clearAudioStream", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearAudioStream"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onHandleData", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onHandleData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onAudioLevelUpdate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onAudioLevelUpdate"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecording", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "startRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stopRecording", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "stopRecording"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateScreenForRecordingStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateScreenForRecordingStatus"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateScreenForSoundStatus", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateScreenForSoundStatus"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "createObjectURL", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createObjectURL"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onSoftReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onSoftReset"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onDeviceDeniedAccess", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onDeviceDeniedAccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "getFormData", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getFormData"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "createBlob", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "createBlob"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setupAudioPlayer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setupAudioPlayer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setUrl", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setUrl"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onTogglePlay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onTogglePlay"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "play", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "play"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "updateTimer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pause", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "pause"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onEnd", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onEnd"), _class.prototype), _class);
var _default = exports["default"] = MediaStore;